import { sendMessage } from '../input-field/index';
import moment from 'moment'
import { isString } from 'lodash';
import * as textUtil from '../../utils/textUtil';

export const ADD_MESSAGE = 'ADD_MESSAGE';
export const ADD_MESSAGES = 'ADD_MESSAGES';
export const ADD_TEXT_LAST_MESSAGE = 'ADD_TEXT_LAST_MESSAGE';
export const SCROLLTOBOTTOM = 'SCROLLTOBOTTOM';
export const SCROLLTOFINISH = 'SCROLLTOFINISH';
export const BUTTON_CLICKED = 'BUTTON_CLICK';
export const BUTTON_POSTBACK = 'BUTTON_POSTBACK';
export const BUTTON_URL_OPEN = 'BUTTON_URL_OPEN';
export const ON_FOCUS_FORM_CELL_INPUT = 'ON_FOCUS_FORM_CELL_INPUT';
export const ON_BLUR_FORM_CELL_INPUT = 'ON_BLUR_FORM_CELL_INPUT';
export const ON_GET_SUGGESTED_QUESTIONS_SUCCESS = 'ON_GET_SUGGESTED_QUESTIONS_SUCCESS';
export const ADD_STREAM_MESSAGE = 'STORE_STREAM_MESSAGE';
export const UPDATE_NEXT_CHUNK_INDEX = 'UPDATE_NEXT_CHUNK_INDEX';
export const CLEAR_STREAM_MESSAGES = 'CLEAR_STREAM_MESSAGES';
export const CANCEL_STREAMING = 'CANCEL_STREAMING';

export const addMessage = (message) => ({
  type: ADD_MESSAGE,
  message
});

export const addMessageEscaped = (message) => {
  return addMessage({
    ...message,
    text: isString(message.text)
      ? textUtil.escapeHTMLTags(message.text)
      : message.text
  });
};

export const addMessages = (messages) => ({
  type: ADD_MESSAGES,
  messages
});

export const scrollToBottom = () => ({
  type: SCROLLTOBOTTOM
});

export const scrollFinished = () => ({
  type: SCROLLTOFINISH
});

export const buttonClicked = () => ({
  type: BUTTON_CLICKED
});

export const buttonPostback = () => ({
  type: BUTTON_POSTBACK
});

export const buttonURLOpen = () => ({
  type: BUTTON_URL_OPEN
});

export const onFocusFormCellInput = () => ({
  type: ON_FOCUS_FORM_CELL_INPUT
});

export const onBlurFormCellInput = () => ({
  type: ON_BLUR_FORM_CELL_INPUT
});

export const getSuggestedQuestionsSuccess = (data) => ({
  type: ON_GET_SUGGESTED_QUESTIONS_SUCCESS,
  payload: data,
});

export const cancelStreaming = (inputSquenceId) => ({
  type: CANCEL_STREAMING,
  inputSquenceId,
});

export const clickOnButton = (buttonAttribute) => (dispatch) => {
  switch (buttonAttribute.type) {
    case 'postback':
      dispatch(buttonClicked());
      dispatch(buttonPostback());
      return dispatch(sendMessage({
        'type': 'postback',
        'data': buttonAttribute.data
      }));
    case 'postback-with-message':
      if (buttonAttribute.url) {
        window.open(buttonAttribute.url, '_blank');
      }
      dispatch(buttonClicked());
      dispatch(buttonPostback());
      dispatch(addMessage({
        'type': 'text',
        'isBot': false,
        'withIcon': true,
        'text': buttonAttribute.text,
        'time': moment(new Date).format('HH:mm'),
      }));
      return dispatch(sendMessage({
        'type': 'postback',
        'text': textUtil.unescapeHTMLSpecialCharacters(buttonAttribute.text),
        'data': buttonAttribute.data
      }));
    case 'url':
      window.open(buttonAttribute.url, '_blank');
      dispatch(buttonClicked());
      return dispatch(buttonURLOpen());
    case 'message':
      dispatch(buttonClicked());
      return dispatch(sendMessage({
        'type': 'text',
        'isBot': false,
        'withIcon': true,
        'text': buttonAttribute.text,
        'time': moment(new Date).format('HH:mm'),
      }));
  }
  return dispatch(buttonClicked());
};

export const addStreamMessage = (message) => ({
  type: ADD_STREAM_MESSAGE,
  message
});

export const clearStreamMessages = () => ({
  type: CLEAR_STREAM_MESSAGES,
});

export const updateNextChunkIndex = (nextChunkIndex) => ({
  type: UPDATE_NEXT_CHUNK_INDEX,
  nextChunkIndex
});

export const addTextLastMessage = (text) => ({
  type: ADD_TEXT_LAST_MESSAGE,
  text
});
